import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { TRelatedCompanies } from '../types';
import { Box, Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput';
import { useAddressQuery } from '~/queries/useAddressQuery';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { FormDateInput } from '~/components/FormComponents/FormDateInput';
import { AddressInfo } from '~/modules/identification/components/FormComponents/AddressInfo';
import { EMPTY_SEPARATE_UNIT, SEPARATE_UNITS } from '../constants';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import FormContainer from '~/modules/identification/components/FormComponents/FormContainer';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

export const SeparateUnits = () => {
  const { control } = useFormContext<TRelatedCompanies>();
  const { nonAgressionCountryOptions } = useAddressQuery();
  const isSeparateUnitsAbsent = useWatch({
    control,
    name: 'isSeparateUnitsAbsent',
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'separateUnits',
  });

  if (isSeparateUnitsAbsent) return null;

  return (
    <Box sx={commonStyles.columnFlexContainer}>
      {fields.map((unit, index) => (
        <FormContainer title={`Відокремлений підрозділ ${index + 1}`} hasBookmark key={unit.id}>
          <FormGridItem>
            <FormInput
              name={`separateUnits.[${index}].fullName`}
              disabled={isSeparateUnitsAbsent}
              label="Повне найменування підрозділу"
              placeholder="Введіть повне найменування підрозділу"
              fullWidth
            />
          </FormGridItem>
          <FormGridItem>
            <FormInput
              name={`separateUnits.[${index}].identificationNumber`}
              disabled={isSeparateUnitsAbsent}
              inputProps={{
                maxLength: 10,
              }}
              label="Код ЄДРПОУ/ реєстраційний номер (за наявності)"
              placeholder="Введіть код ЄДРПОУ/ реєстраційний номер"
              fullWidth
            />
          </FormGridItem>
          <FormGridItem>
            <FormAutocomplete
              options={nonAgressionCountryOptions}
              name={`separateUnits.[${index}].residenceCountry`}
              disabled={isSeparateUnitsAbsent}
              inputProps={{
                placeholder: 'Оберіть країну резидентності',
              }}
              label="Країна резидентності"
            />
          </FormGridItem>
          <FormGridItem>
            <FormDateInput
              name={`separateUnits.[${index}].unitRegistrationDate`}
              placeholder={'Введіть або оберіть дату державної реєстрації'}
              label="Дата державної реєстрації"
              disabled={isSeparateUnitsAbsent}
              isCurrentMaxDate
            />
          </FormGridItem>
          <AddressInfo section={`separateUnits.[${index}]`} />
          <FormGridItem sx={{ alignContent: 'flex-end' }}>
            <FormAutocomplete
              options={SEPARATE_UNITS}
              name={`separateUnits.[${index}].separateUnitType`}
              disabled={isSeparateUnitsAbsent}
              inputProps={{
                placeholder: 'Оберіть ознаку відокремленого підрозділу',
              }}
              label="Ознака відокремленого підрозділу"
            />
          </FormGridItem>
          <Grid size={12}>
            <AddRemoveBlock
              add={() => append(EMPTY_SEPARATE_UNIT)}
              remove={() => remove(index)}
              isPlusShown={fields.length <= 30}
              isMinusShown={fields.length > 1}
              plusText='Натисніть на "+" для додавання інформації про відокремлені підрозділи.'
              minusText='Натисніть на "-" для видалення інформації про відокремлені підрозділи.'
            />
          </Grid>
        </FormContainer>
      ))}
    </Box>
  );
};
